// @flow
import * as React from 'react';
import Error204 from '../Error204/container';
import Error404 from '../Error404/container';

type Props = {
  queryText: string,
  isNotFound: boolean,
};

function ErrorNotFound({ queryText, isNotFound }: Props): React.Node {
  // $FlowFixMe
  return <div>{isNotFound ? <Error204 what={queryText} /> : <Error404 what={queryText} />}</div>;
}

export default ErrorNotFound;



// WEBPACK FOOTER //
// ./app/Error/components/ErrorNotFound/index.js